export default __webpack_public_path__ + "static/media/title-bg.130a6d57.jpg";